const initialState = {
    import_data: [],
    import_count: 0,
    isReadingImports: false,
    isReadingImportCSV: false,
    isAddingImport: false,
    isReadingImport: false,
    importBeingUpdated: null,
    importBeingDeleted: null,
    isReadingProfileUploads: false,
    isProfileUploads: false,
    profileUploadDeleted: false,
    profileUploads: [],


    import_info: {},
    csv: null
}

export default initialState;
